const promiseMngt = {
    namespaced: true,
    state : {
        promiseGoodsCd : '',
        status : '',
        promiseGoodsInfo : {},
    },
    getters: {
        getPromiseGoodsCd (state) {
            return state.promiseGoodsCd
        },
        getStatus (state) {
            return state.status
        },
        getPromiseGoodsInfo (state) {
            return state.promiseGoodsInfo
        }

    },
    mutations: {
        setPromiseGoodsCd (state, payload) {
            state.promiseGoodsCd = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },
        setPromiseGoodsInfo (state, payload) {
            state.promiseGoodsInfo = payload
        },

    },
    actions: {
        setPromiseGoodsCd ({commit}, payload) {
            commit('setPromiseGoodsCd', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setPromiseGoodsInfo ({commit}, payload) {
            commit('setPromiseGoodsInfo', payload)
        },
        setPromiseinit ({commit}) {
            commit('setPromiseGoodsCd','');
            commit('setStatus','');
            commit('setPromiseGoodsInfo',{});
        },
    }
}


export default promiseMngt